var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIconWhiteBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20819_39147)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5586 1.46182C13.8594 0.735256 14.6523 0.348537 15.4102 0.555568L18.8477 1.49307C19.5273 1.68057 20 2.29776 20 3.00088C20 12.6649 12.1641 20.5009 2.5 20.5009C1.79688 20.5009 1.17969 20.0282 0.992188 19.3485L0.0546875 15.911C-0.152344 15.1532 0.234375 14.3603 0.960938 14.0595L4.71094 12.497C5.34766 12.2313 6.08594 12.4149 6.51953 12.9501L8.09766 14.8759C10.8477 13.5751 13.0742 11.3485 14.375 8.59854L12.4492 7.02432C11.9141 6.58682 11.7305 5.85244 11.9961 5.21572L13.5586 1.46572V1.46182Z",
    fill: "#091644"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20819_39147"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "matrix(-1 0 0 1 20 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIconWhiteBackground);
export default __webpack_public_path__ + "static/media/phone_icon_white_background.a002cd3ee2a9ce8590fdbd0932ee1ad3.svg";
export { ForwardRef as ReactComponent };